"use client";

import React, {useEffect, useRef, useState} from "react";
// 如果你有一个通用的函数式弹窗组件（SDialogFC）可复用它；
// 或者自己写一个基础 Layout 也行，这里示例用 SDialogFC:
import { SDialogFC } from "@/Master/SDialogFC/SDialogFC";
import { SDialogProps } from "@/Master/SDialogFC/SDialogFC";
import styles from "./UI.module.css";
import {useDialogMethods} from "@/Master/SDialogFC/useDialogMethods";

/** 如果你需要对外暴露一个是否确认的结果，需要定义 Props / 回调 */
interface RedeemConfirmDialogProps extends SDialogProps {
    /** 打开弹窗时，可带一些额外参数。*/
    // e.g. defaultMsg?: string;
    onDialogResult?: (isOk: boolean) => void;
}

/**
 * 函数组件版 RedeemConfirmDialog
 */
export const RedeemConfirmDialogFC: React.FC<RedeemConfirmDialogProps> = (props) => {
    const {fcKey,onClose} = props;

    // 相当于 class 里的  public isOk = false;
    const [isOk, setIsOk] = useState(false);

    // 用一个内部 state 控制对话框是否还可见
    const [isOpen, setIsOpen] = useState(true);

    const { closeDialog } = useDialogMethods(fcKey,{
        close: () => {
            onClose?.(isOpen)
        },
    });


    // ========== 模拟原先的生命周期 ==========

    /** 原先 initData(...args) + onInit + onEnter + onInitTouch */
    useEffect(() => {
        console.log("RedeemConfirmDialog initData", props);
        console.log("RedeemConfirmDialog initialized");
        console.log("RedeemConfirmDialog entered");
        console.log("RedeemConfirmDialog touch initialized");

        return () => {
            console.log("RedeemConfirmDialog disposed (componentWillUnmount)");
        };
    }, [props]);

    /** 相当于 onClose */
    function handleClose() {
        console.log("RedeemConfirmDialog onClose");
        // 如果外部需要知道最终结果，可以在此回调
        props.onDialogResult?.(isOk);
        setIsOpen(false);
    }

    /** 模拟 onExit */
    function onExit() {
        console.log("RedeemConfirmDialog onExit");
    }

    // ========== 业务逻辑：按钮点击 ==========

    /** 对应 class 里的 `private onAction(open: boolean)` */
    function onAction(ok: boolean) {
        setIsOk(ok);
        // 先执行 onExit
        onExit();
        // 再执行 onClose
        handleClose();
        closeDialog();
        onClose?.(ok);
    }

    // 如果已关闭，就不再渲染
    if (!isOpen) return null;

    // ========== 渲染 UI ==========

    return (
        <SDialogFC
            isOpen={isOpen}
            mode="Center"
            // 这里相当于 `_title = 'Please Confirm \n Your Account'`
            title={"Please Confirm \n Your Account"}
            // 按钮数组
            buttons={[
                { label: "Return", onClick: () => onAction(false), style: "blueBtn" },
                { label: "Confirm", onClick: () => onAction(true), style: "greenBtn" },
            ]}
            {...props}
        >
            <div className={styles.confirmBody}>
                <p>
                    To keep your account safe and be able to redeem your prize, please
                    verify your account using our secure identity check provider.
                </p>
            </div>
        </SDialogFC>
    );
};
